import { ensureProtectedNetworkAccess, setAuthState } from './authStatus'
import { getAccessToken } from './authToken'
import { AuthExpiredError } from './authErrors'
import { dispatchAuthExpired } from './authEvents'

export async function buildProtectedAuthHeaders(
  context: string,
  baseHeaders: Record<string, string> = {},
): Promise<Record<string, string>> {
  ensureProtectedNetworkAccess(context)

  const token = await getAccessToken()
  if (!token) {
    setAuthState({ tokenStatus: 'expired' })
    dispatchAuthExpired({ context, reason: 'token_unavailable' })
    throw new AuthExpiredError()
  }

  setAuthState({ tokenStatus: 'ready' })
  return {
    ...baseHeaders,
    Authorization: `Bearer ${token}`,
  }
}
